import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-radio-button-wrapper",
    class: {
      "mp-radio-button-selected": this.attr(`selected`),
      "mp-radio-button-disabled": this.attr(`disabled`),
      "mp-radio-button-focused": this.attr(`focused`),
      "mp-radio-button-lite": this.attr(`theme`) === `lite`,
      "mp-radio-button-primary": this.attr(`theme`) === `primary`
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-radio-button-button"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-radio-button-animation-layer"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".mp-radio-button-dot"
  })), this.attr(`icon`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-radio-button-content"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: this.attr(`icon`) }
  })) : null, /* @__PURE__ */ jsx("slot", null));
}
